var _animateTransform;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckingScale({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.4802,
    height: 23.4802,
    viewBox: "0 0 23.4802 23.4802",
    id: "svg18",
    style: {
      fill: "none"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    id: "g11",
    transform: "translate(-1.0459003,-1.2341003)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: -10,
    y: -10,
    width: 48,
    height: 55
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13.5049,-9.03871 H 37.0001 V 44.5255 H 12.7862 V 35.5781 L 7.03475,35.5784 12.3324,14.0076 -0.582527,31.238 -5.65472,25.9602 12.4641,13.4714 l 0.0815,-0.3317 0.0579,0.2356 0.1827,-0.1259 V 13.0617 L -5.65472,0.350887 -0.582527,-4.92688 12.7862,12.9089 V 12.1775 L 7.88418,-9.14478 Z m -0.7187,22.44091 -0.1326,0.1769 0.1326,0.5397 z M -9.83626,16.7957 12.5443,13.0919 -9.85059,9.47578 Z",
    id: "path2",
    style: {
      clipRule: "evenodd",
      fill: "#ffffff",
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)",
    id: "g7"
  }, _animateTransform || (_animateTransform = /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    begin: "0s",
    dur: "1s",
    type: "rotate",
    from: "0 12.786 12.9742",
    to: "360 12.786 12.9742",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 12.786,
    cy: 12.9742,
    r: 10.7401,
    id: "circle5",
    style: {
      stroke: "#000000",
      strokeWidth: 2,
      strokeOpacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 19.3896,15.481 v -4.2803 c 0,-0.2364 -0.1847,-0.428 -0.4127,-0.428 H 6.59478 c -0.22796,0 -0.41274,0.1916 -0.41274,0.428 v 4.2803 c 0,0.2364 0.18478,0.428 0.41274,0.428 H 18.9769 c 0.228,0 0.4127,-0.1917 0.4127,-0.428 z M 7.00752,15.0529 v -3.4241 h 1.23821 v 2.1401 h 0.82548 v -2.1401 h 1.23819 v 1.284 h 0.8255 v -1.284 h 1.2382 v 2.1401 h 0.8255 v -2.1401 h 1.2382 v 1.284 h 0.8255 v -1.284 h 1.2382 v 2.1401 h 0.8255 v -2.1401 h 1.2382 v 3.4241 z",
    id: "path9",
    style: {
      fill: "#000000",
      fillOpacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    id: "rect13",
    x: 0,
    y: 0,
    style: {
      fill: "#ffffff"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckingScale);
export default __webpack_public_path__ + "static/media/checking-scale.d9917551a6e99f0a8177f549efa8c0bb.svg";
export { ForwardRef as ReactComponent };